angular.module('CarsSaraBo').factory('PointOfSaleService', ['$resource', 'ItemSelectorService', 'ContractService',
		function ($resource, itemSelectorService, contractService) {


            return {
                resource: $resource('../rest/company/:companyOid/pointOfSale/:oid',
                    {
                        companyOid: '@companyOid',
                        oid: '@oid'
                    },
                    {
                        update: {method: 'PUT'},
                        getAll: {method: 'GET', isArray: true},
                        save: {method: 'POST'}
                    }
                ),

                getPointsOfSaleSelectorConfig: function (pointsOfSale, selectedPointsOfSale) {
                    var nameGenerator = function (pos) {
                        return pos.name;
                    };
                    var items = itemSelectorService.getItemsForSelector(pointsOfSale, selectedPointsOfSale, nameGenerator);

                    return itemSelectorService.newItemSelectorBuilder()
                        .listOfItemsTitle("specialOffers.posSelector.listOfItemsTitle")
                        .listOfSelectedItemsTitle("specialOffers.posSelector.listOfSelectedItemsTitle")
                        .items(items)
                        .build();
                },

            }
        }]);

angular.module('CarsSaraBo').factory('PointOfSaleServiceAll', ['$resource', function ($resource) {
	return $resource('../rest/company/:companyOid/pointOfSale/all',
		{
			companyOid: '@companyOid',
		},
		{
			remove: {method: 'DELETE'},
		}
	)
}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/pointofsale_service.js
// module id = 859
// module chunks = 3